import { verifyOtpResponse } from "../types/DTO";

export function getInitData(): Omit<verifyOtpResponse, "accessToken" | "refreshToken" | "shopId"> | null {
  const raw = localStorage.getItem("agent_init_data");
  if (!raw) return null; // not found

  try {
    return JSON.parse(raw);
  } catch (e) {
    console.error("Invalid agent_init_data in localStorage", e);
    return null; // corrupted
  }
}
